<template>
  <div>
    <div v-if="(animalGroups.length !== 0)">
      <div>
        <v-card flat color="transparent" class="mt-7">
          <v-toolbar class="bdr secondary2light" :elevation="0" outlined>
            <v-toolbar-title class="grey--text text--darken-2" style="font-size: 18px">{{ $t("currentGroupInfo")
            }}</v-toolbar-title>
          </v-toolbar>
        </v-card>
        <v-data-table v-model="selected" :headers="headers" :items="animalGroups" item-key="id" :items-per-page="10"
          hide-default-footer :loading="loading" :loading-text="$t('loadingData')" show-select>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex">
              <div class="action-primary" @click="moveToGroup(item)">Move To Another Group</div>
              <div class="ml-2 action-delete" @click="removeGroup(item)">Remove From Group</div>
            </div>
          </template>
          <template v-slot:footer></template>
        </v-data-table>
      </div>
      <div>
        <v-card flat color="transparent" class="mt-7">
          <v-toolbar class="bdr secondary2light" :elevation="0" outlined>
            <v-toolbar-title class="grey--text text--darken-2" style="font-size: 18px">Animal Group History
            </v-toolbar-title>
          </v-toolbar>
        </v-card>
        <v-card flat class="mt-7">
          <v-card-text>
            <v-data-table v-model="selected" :headers="historyHeaders" :items="groupHistory" item-key="id"
              :items-per-page="30" hide-default-footer :loading="loading" :loading-text="$t('loadingData')" show-select>
              <template v-slot:item.actions="{ item }">
                <v-icon color="red" @click="deleteHistory(item)">
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:footer></template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <div v-if="(animalGroups.length == 0)" class="add-new-group">
      <div style="height: 61px; width: 51px;">
        <v-img src="/icons/GroupNote.svg" width="50" heigth="60"></v-img>
      </div>
      <p class="group-empty-header">{{ $t('noRecordFound') }}</p>
      <p class="group-empty-description">{{ $t('thisAnimalNotAssociatedWithGroup') }}</p>
      <v-btn @click="moveToGroup(null)" right class="ml-5" height="50" width="183" color="primary">
        {{ $t('addToGroup') }}
      </v-btn>
    </div>
    <CreateGroupFromExistingDialog v-if="showCreateGroupFromExistingDialog" :dialogI="showCreateGroupFromExistingDialog"
      :groups="showGroups" @closeDialog="showCreateGroupFromExistingDialog = false"
      @group:selected="onExistingGroupSelected" @new-group:create="onNewGroupCreate">
    </CreateGroupFromExistingDialog>
    <CreateGroupDialog @closeDialog="showCreateGroupDialog = false" @group:created="onGroupCreated"
      :animalCategories="animalCategories" :dialogI="showCreateGroupDialog" :newGroupName="newGroupName"
      v-if="showCreateGroupDialog" />
    <RemoveAnimalsDialog @modal:closed="showRemoveAnimalsDialog = false" @remove:animals="removeAnimals"
      :dialogI="showRemoveAnimalsDialog" v-if="showRemoveAnimalsDialog" />
    <DeletePopup :dialogI="showDeleteDialog" v-if="showDeleteDialog" @delete="onDelete"
      @closeDialog="closeDeleteDialog" />
  </div>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import gql from "graphql-tag";
import CreateGroupDialog from "../CreateGroupDialog.vue";
import CreateGroupFromExistingDialog from "../CreateGroupFromExistingDialog.vue";
import DeletePopup from "../DeletePopup.vue";
import RemoveAnimalsDialog from "../groups/RemoveAnimalsDialog.vue";

export default {
  apollo: {
    groups: {
      query: gql`
        query groups {
          groups {
            groupData {
              id
              animalCounts
              bodyWeight
              name
              status
              geofenceZoneId {
                id
                geofenceName
              }
            }
            groupToAnimals
          }
        }
      `,
      skip: () => false,
      fetchPolicy: "network-only",
      update: (data) => data.groups.groupData,
      result({ data }) {
        this.groupToAnimals = data.groups.groupToAnimals;
        this.groupData = data.groups.groupData;
        for (let el in data.groups.groupToAnimals) {
          this.animalIds.push(...data.groups.groupToAnimals[el]);
        }
      },
    },
    animalGroups: {
      query: gql`
        query GroupByAnimalId($animalId: Int!) {
          groupByAnimalId(animalId: $animalId) {
            id,
            animalCategoryId,
            animalTypeId,
            name,
            status,
            geofenceZoneId { id }
            animalCategory {
              id
              name
            }
          }
        }
      `,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      update: (data) => data.groupByAnimalId,
      error: (err) => this.$notify({
        title: "Error loading group by animalid!",
        text: err,
        type: "error",
        position: "top right",
      }),
    },
    animalCategories: {
      query: gql`
        query animalCategories {
          animalCategories {
            id
            name
          }
        }
      `,
      update: (data) => data.animalCategories,
    },
    groupHistory: {
      query: gql`
        query GroupHistoryByAnimalId($animalId: Int!) {
          groupHistoryByAnimalId(animalId: $animalId) {
            id,
            group {
              name
              animalCategory {
              id
              name
              } 
            }
            status,                  
          }
        }
      `,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      update: (data) => data.groupHistoryByAnimalId,
      error: (err) =>
        this.$notify({
          title: "Error loading group by animalid!",
          text: err,
          type: "error",
          position: "top right",
        }),
    }
  },
  data() {
    return {
      selected: [],
      groupHistory: [],
      selectedGroup: {},
      selectedHistory: {},
      loading: false,
      showCreateGroupFromExistingDialog: false,
      showCreateGroupDialog: false,
      showRemoveAnimalsDialog: false,
      showDeleteDialog: false,
      newGroupName: "",
      groups: [],
      animalGroups: [],
      groupToAnimals: null,
      animalIds: [],
      groupData: [],
      animalCategories: [],
      headers: [
        {
          text: "Group Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: "Farm Zone",
          align: "start",
          sortable: true,
          value: "geofenceZoneId.geofenceName",
        },
        {
          text: "Animal Category",
          align: "start",
          sortable: true,
          value: "animalCategory.name"
        },
        { text: "Group Status", sortable: true, value: "status" },
        { text: "", value: "actions", align: "start" }
      ],
      historyHeaders: [
        {
          text: "Group Name",
          align: "start",
          sortable: true,
          value: "group.name",
        },
        {
          text: "Farm Zone",
          align: "start",
          sortable: true,
          value: "",
        },
        {
          text: "Animal Category",
          align: "start",
          sortable: true,
          value: "group.animalCategory.name"
        },
        { text: "Group Status", sortable: true, value: "status" },
        { text: "", value: "actions", align: 'start' }
      ]
    };
  },
  computed: {
    showGroups() {
      let _group = [...this.groups]
      let _animalGroup = this.animalGroups.map(el => el.id)
      return _group.filter(item => !_animalGroup.includes(item.id))
    },
  },
  methods: {
    moveToGroup(item) {
      this.selectedGroup = item;
      this.showCreateGroupFromExistingDialog = true;
    },
    removeGroup(item) {
      this.selectedGroup = item;
      this.showRemoveAnimalsDialog = true
    },
    onNewGroupCreate(newGroupName) {
      if (newGroupName) {
        this.newGroupName = newGroupName;
        this.showCreateGroupFromExistingDialog = false;
        this.showCreateGroupDialog = true;
      }
    },
    async onExistingGroupSelected(existingGroupId) {
      if (existingGroupId) {
        let animalToUpdate = {
          id: parseInt(this.$route.params.animal_number),
          groupId: parseInt(existingGroupId),
          currentGroupId: this.selectedGroup?.id ? parseInt(this.selectedGroup.id) : null
        };
        await this.updateAnimal(animalToUpdate);
        this.showCreateGroupFromExistingDialog = false;
      }
    },
    async onGroupCreated(newGroup) {
      await this.$apollo.queries.groups.refetch();
      let animalToUpdate = {
        id: parseInt(this.$route.params.animal_number),
        groupId: parseInt(newGroup.id),
        currentGroupId: this.selectedGroup?.id ? parseInt(this.selectedGroup.id) : null
      };
      await this.updateAnimal(animalToUpdate);
    },
    async updateAnimal(animalToUpdate) {
      this.startLoading();

      let formData = {
        animalIds: [parseInt(this.$route.params.animal_number)],
        groupId: animalToUpdate.groupId,
        oldGroupId: animalToUpdate.currentGroupId
      };

      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation ($data: AssignAnimalsToGroupInput!) {
              assignAnimalsToGroup(assignAnimalsToGroup: $data)
            }
          `,
          // Parameters
          variables: {
            data: formData,
          },
        })
        .then((res) => {
          if (res.data.assignAnimalsToGroup) {
            this.$apollo.queries.animalGroups.refetch();
            this.$apollo.queries.groupHistory.refetch(); this.stopLoading();

            this.$notify({
              title: "Animal Group Updated Successfully",
              text: "", //res.message,
              type: "success",
            });
          } else {
            this.stopLoading();
            this.$notify({
              title: "Animal Group Not Updated",
              text: res.message,
              type: "error",
            });
          }
        })
        .catch(({ data }) => {
          if (data.status == 422) {
            data.message.errors.forEach((em) => {
              this.errors[em.param] = em.msg;
            });
          }
          this.stopLoading();
        });
    },
    removeAnimals() {

      this.$apollo.mutate({
        // Query
        mutation: gql`mutation removeAnimalsFromGroup($data: RemoveAnimalsFromGroupInput!) {
                    removeAnimalsFromGroup(removeAnimalsFromGroup: $data)
                }`,
        // Parameters
        variables: {
          data: {
            animalIds: [parseInt(this.$route.params.animal_number)],
            groupId: parseInt(this.selectedGroup.id)
          }
        },
      }).then(() => {
        this.showRemoveAnimalsDialog = false;
        this.$apollo.queries.animalGroups.refetch();
        this.$apollo.queries.groupHistory.refetch();
      })
    },
    deleteHistory(item) {
      this.selectedHistory = item;
      this.showDeleteDialog = true
    },
    closeDeleteDialog() {
      this.showDeleteDialog = false;
      this.selectedHistory = null;
    },
    async onDelete() {
      await this.$apollo.mutate({
        mutation: gql`mutation deleteAnimalGroupHistory($id: Int!) {deleteAnimalGroupHistory(id: $id)}`,
        variables: {
          id: parseInt(this.selectedHistory.id)
        },
      }).then(async (res) => {
        this.$notify({
          title: `History deleted successfully`,
          text: res.message,
          type: "success",
          position: "top right",
        });
        this.showDeleteDialog = false;
        this.$apollo.queries.groupHistory.refetch();
      });
    },
  },
  mixins: [loadingMixin],
  components: { CreateGroupFromExistingDialog, CreateGroupDialog, RemoveAnimalsDialog, DeletePopup }
};
</script>
<style lang="scss" scoped>
.action-primary {
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-decoration-line: underline;
  color: #00BD73;
  cursor: pointer;
}

.action-delete {
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-decoration-line: underline;
  color: #F03737;
  cursor: pointer;
}

.add-new-group {
  min-height: 100vh;
  display: flex;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.group-empty-header {
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  display: flex;
  align-items: center;
  color: #1E1E1E;
  margin-top: 10px;
}

.group-empty-description {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #787878;
}
</style>